import ie, { createContext as W, useContext as $, useState as ae, useEffect as Le, useCallback as q, Fragment as wr } from "react";
import "@for-it/domain-lib";
var oe = { exports: {} }, N = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var De;
function Er() {
  if (De) return N;
  De = 1;
  var l = ie, i = Symbol.for("react.element"), d = Symbol.for("react.fragment"), v = Object.prototype.hasOwnProperty, w = l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, x = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(g, h, C) {
    var E, S = {}, u = null, b = null;
    C !== void 0 && (u = "" + C), h.key !== void 0 && (u = "" + h.key), h.ref !== void 0 && (b = h.ref);
    for (E in h) v.call(h, E) && !x.hasOwnProperty(E) && (S[E] = h[E]);
    if (g && g.defaultProps) for (E in h = g.defaultProps, h) S[E] === void 0 && (S[E] = h[E]);
    return { $$typeof: i, type: g, key: u, ref: b, props: S, _owner: w.current };
  }
  return N.Fragment = d, N.jsx = f, N.jsxs = f, N;
}
var Y = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Me;
function Rr() {
  return Me || (Me = 1, process.env.NODE_ENV !== "production" && function() {
    var l = ie, i = Symbol.for("react.element"), d = Symbol.for("react.portal"), v = Symbol.for("react.fragment"), w = Symbol.for("react.strict_mode"), x = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), g = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), C = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), S = Symbol.for("react.memo"), u = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), P = Symbol.iterator, G = "@@iterator";
    function Ye(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = P && e[P] || e[G];
      return typeof r == "function" ? r : null;
    }
    var A = l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function R(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
          t[n - 1] = arguments[n];
        We("error", e, t);
      }
    }
    function We(e, r, t) {
      {
        var n = A.ReactDebugCurrentFrame, s = n.getStackAddendum();
        s !== "" && (r += "%s", t = t.concat([s]));
        var c = t.map(function(o) {
          return String(o);
        });
        c.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, c);
      }
    }
    var $e = !1, Ue = !1, Ve = !1, Be = !1, Je = !1, le;
    le = Symbol.for("react.module.reference");
    function qe(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === v || e === x || Je || e === w || e === C || e === E || Be || e === b || $e || Ue || Ve || typeof e == "object" && e !== null && (e.$$typeof === u || e.$$typeof === S || e.$$typeof === f || e.$$typeof === g || e.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === le || e.getModuleId !== void 0));
    }
    function Ke(e, r, t) {
      var n = e.displayName;
      if (n)
        return n;
      var s = r.displayName || r.name || "";
      return s !== "" ? t + "(" + s + ")" : t;
    }
    function ce(e) {
      return e.displayName || "Context";
    }
    function O(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && R("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case v:
          return "Fragment";
        case d:
          return "Portal";
        case x:
          return "Profiler";
        case w:
          return "StrictMode";
        case C:
          return "Suspense";
        case E:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case g:
            var r = e;
            return ce(r) + ".Consumer";
          case f:
            var t = e;
            return ce(t._context) + ".Provider";
          case h:
            return Ke(e, e.render, "ForwardRef");
          case S:
            var n = e.displayName || null;
            return n !== null ? n : O(e.type) || "Memo";
          case u: {
            var s = e, c = s._payload, o = s._init;
            try {
              return O(o(c));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var k = Object.assign, I = 0, fe, de, ve, pe, ge, he, me;
    function ye() {
    }
    ye.__reactDisabledLog = !0;
    function ze() {
      {
        if (I === 0) {
          fe = console.log, de = console.info, ve = console.warn, pe = console.error, ge = console.group, he = console.groupCollapsed, me = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: ye,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        I++;
      }
    }
    function Ge() {
      {
        if (I--, I === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: k({}, e, {
              value: fe
            }),
            info: k({}, e, {
              value: de
            }),
            warn: k({}, e, {
              value: ve
            }),
            error: k({}, e, {
              value: pe
            }),
            group: k({}, e, {
              value: ge
            }),
            groupCollapsed: k({}, e, {
              value: he
            }),
            groupEnd: k({}, e, {
              value: me
            })
          });
        }
        I < 0 && R("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var X = A.ReactCurrentDispatcher, H;
    function U(e, r, t) {
      {
        if (H === void 0)
          try {
            throw Error();
          } catch (s) {
            var n = s.stack.trim().match(/\n( *(at )?)/);
            H = n && n[1] || "";
          }
        return `
` + H + e;
      }
    }
    var Q = !1, V;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      V = new Xe();
    }
    function be(e, r) {
      if (!e || Q)
        return "";
      {
        var t = V.get(e);
        if (t !== void 0)
          return t;
      }
      var n;
      Q = !0;
      var s = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var c;
      c = X.current, X.current = null, ze();
      try {
        if (r) {
          var o = function() {
            throw Error();
          };
          if (Object.defineProperty(o.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(o, []);
            } catch (j) {
              n = j;
            }
            Reflect.construct(e, [], o);
          } else {
            try {
              o.call();
            } catch (j) {
              n = j;
            }
            e.call(o.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (j) {
            n = j;
          }
          e();
        }
      } catch (j) {
        if (j && n && typeof j.stack == "string") {
          for (var a = j.stack.split(`
`), _ = n.stack.split(`
`), m = a.length - 1, y = _.length - 1; m >= 1 && y >= 0 && a[m] !== _[y]; )
            y--;
          for (; m >= 1 && y >= 0; m--, y--)
            if (a[m] !== _[y]) {
              if (m !== 1 || y !== 1)
                do
                  if (m--, y--, y < 0 || a[m] !== _[y]) {
                    var T = `
` + a[m].replace(" at new ", " at ");
                    return e.displayName && T.includes("<anonymous>") && (T = T.replace("<anonymous>", e.displayName)), typeof e == "function" && V.set(e, T), T;
                  }
                while (m >= 1 && y >= 0);
              break;
            }
        }
      } finally {
        Q = !1, X.current = c, Ge(), Error.prepareStackTrace = s;
      }
      var M = e ? e.displayName || e.name : "", F = M ? U(M) : "";
      return typeof e == "function" && V.set(e, F), F;
    }
    function He(e, r, t) {
      return be(e, !1);
    }
    function Qe(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function B(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return be(e, Qe(e));
      if (typeof e == "string")
        return U(e);
      switch (e) {
        case C:
          return U("Suspense");
        case E:
          return U("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case h:
            return He(e.render);
          case S:
            return B(e.type, r, t);
          case u: {
            var n = e, s = n._payload, c = n._init;
            try {
              return B(c(s), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var L = Object.prototype.hasOwnProperty, xe = {}, we = A.ReactDebugCurrentFrame;
    function J(e) {
      if (e) {
        var r = e._owner, t = B(e.type, e._source, r ? r.type : null);
        we.setExtraStackFrame(t);
      } else
        we.setExtraStackFrame(null);
    }
    function Ze(e, r, t, n, s) {
      {
        var c = Function.call.bind(L);
        for (var o in e)
          if (c(e, o)) {
            var a = void 0;
            try {
              if (typeof e[o] != "function") {
                var _ = Error((n || "React class") + ": " + t + " type `" + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[o] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw _.name = "Invariant Violation", _;
              }
              a = e[o](r, o, n, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (m) {
              a = m;
            }
            a && !(a instanceof Error) && (J(s), R("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", n || "React class", t, o, typeof a), J(null)), a instanceof Error && !(a.message in xe) && (xe[a.message] = !0, J(s), R("Failed %s type: %s", t, a.message), J(null));
          }
      }
    }
    var er = Array.isArray;
    function Z(e) {
      return er(e);
    }
    function rr(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function tr(e) {
      try {
        return Ee(e), !1;
      } catch {
        return !0;
      }
    }
    function Ee(e) {
      return "" + e;
    }
    function Re(e) {
      if (tr(e))
        return R("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", rr(e)), Ee(e);
    }
    var _e = A.ReactCurrentOwner, nr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Te;
    function ar(e) {
      if (L.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function or(e) {
      if (L.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function ir(e, r) {
      typeof e.ref == "string" && _e.current;
    }
    function sr(e, r) {
      {
        var t = function() {
          je || (je = !0, R("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function ur(e, r) {
      {
        var t = function() {
          Te || (Te = !0, R("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var lr = function(e, r, t, n, s, c, o) {
      var a = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: i,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: o,
        // Record the component responsible for creating this element.
        _owner: c
      };
      return a._store = {}, Object.defineProperty(a._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(a, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: n
      }), Object.defineProperty(a, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: s
      }), Object.freeze && (Object.freeze(a.props), Object.freeze(a)), a;
    };
    function cr(e, r, t, n, s) {
      {
        var c, o = {}, a = null, _ = null;
        t !== void 0 && (Re(t), a = "" + t), or(r) && (Re(r.key), a = "" + r.key), ar(r) && (_ = r.ref, ir(r, s));
        for (c in r)
          L.call(r, c) && !nr.hasOwnProperty(c) && (o[c] = r[c]);
        if (e && e.defaultProps) {
          var m = e.defaultProps;
          for (c in m)
            o[c] === void 0 && (o[c] = m[c]);
        }
        if (a || _) {
          var y = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          a && sr(o, y), _ && ur(o, y);
        }
        return lr(e, a, _, s, n, _e.current, o);
      }
    }
    var ee = A.ReactCurrentOwner, Se = A.ReactDebugCurrentFrame;
    function D(e) {
      if (e) {
        var r = e._owner, t = B(e.type, e._source, r ? r.type : null);
        Se.setExtraStackFrame(t);
      } else
        Se.setExtraStackFrame(null);
    }
    var re;
    re = !1;
    function te(e) {
      return typeof e == "object" && e !== null && e.$$typeof === i;
    }
    function Ce() {
      {
        if (ee.current) {
          var e = O(ee.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function fr(e) {
      return "";
    }
    var Pe = {};
    function dr(e) {
      {
        var r = Ce();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function Oe(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = dr(r);
        if (Pe[t])
          return;
        Pe[t] = !0;
        var n = "";
        e && e._owner && e._owner !== ee.current && (n = " It was passed a child from " + O(e._owner.type) + "."), D(e), R('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, n), D(null);
      }
    }
    function ke(e, r) {
      {
        if (typeof e != "object")
          return;
        if (Z(e))
          for (var t = 0; t < e.length; t++) {
            var n = e[t];
            te(n) && Oe(n, r);
          }
        else if (te(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var s = Ye(e);
          if (typeof s == "function" && s !== e.entries)
            for (var c = s.call(e), o; !(o = c.next()).done; )
              te(o.value) && Oe(o.value, r);
        }
      }
    }
    function vr(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === h || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === S))
          t = r.propTypes;
        else
          return;
        if (t) {
          var n = O(r);
          Ze(t, e.props, "prop", n, e);
        } else if (r.PropTypes !== void 0 && !re) {
          re = !0;
          var s = O(r);
          R("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", s || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && R("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function pr(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var n = r[t];
          if (n !== "children" && n !== "key") {
            D(e), R("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n), D(null);
            break;
          }
        }
        e.ref !== null && (D(e), R("Invalid attribute `ref` supplied to `React.Fragment`."), D(null));
      }
    }
    var Fe = {};
    function Ae(e, r, t, n, s, c) {
      {
        var o = qe(e);
        if (!o) {
          var a = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (a += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var _ = fr();
          _ ? a += _ : a += Ce();
          var m;
          e === null ? m = "null" : Z(e) ? m = "array" : e !== void 0 && e.$$typeof === i ? (m = "<" + (O(e.type) || "Unknown") + " />", a = " Did you accidentally export a JSX literal instead of a component?") : m = typeof e, R("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", m, a);
        }
        var y = cr(e, r, t, s, c);
        if (y == null)
          return y;
        if (o) {
          var T = r.children;
          if (T !== void 0)
            if (n)
              if (Z(T)) {
                for (var M = 0; M < T.length; M++)
                  ke(T[M], e);
                Object.freeze && Object.freeze(T);
              } else
                R("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ke(T, e);
        }
        if (L.call(r, "key")) {
          var F = O(e), j = Object.keys(r).filter(function(xr) {
            return xr !== "key";
          }), ne = j.length > 0 ? "{key: someKey, " + j.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Fe[F + ne]) {
            var br = j.length > 0 ? "{" + j.join(": ..., ") + ": ...}" : "{}";
            R(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ne, F, br, F), Fe[F + ne] = !0;
          }
        }
        return e === v ? pr(y) : vr(y), y;
      }
    }
    function gr(e, r, t) {
      return Ae(e, r, t, !0);
    }
    function hr(e, r, t) {
      return Ae(e, r, t, !1);
    }
    var mr = hr, yr = gr;
    Y.Fragment = v, Y.jsx = mr, Y.jsxs = yr;
  }()), Y;
}
process.env.NODE_ENV === "production" ? oe.exports = Er() : oe.exports = Rr();
var p = oe.exports;
const Mr = W({
  notifyError: () => {
  }
}), Ir = W({
  location: void 0,
  navigate: {
    toRoute: () => {
    },
    toUrl: () => {
    },
    back: () => {
    }
  }
}), z = W({
  call: () => Promise.resolve(void 0),
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  isLoggedIn: !1
});
function _r() {
  return $(z);
}
function Lr() {
  const { login: l } = $(z);
  return l;
}
function Nr() {
  const { logout: l } = $(z);
  return l;
}
function jr() {
  return $(z);
}
function Yr() {
  return jr().currentUser;
}
const Tr = W({
  showConfirmationModal: () => {
  },
  async withLoadingModal() {
  },
  showCustomModal: () => {
  },
  lockBodyScroll: () => {
  },
  unlockBodyScroll: () => {
  }
});
function se(...l) {
  return l.filter(
    (i) => typeof i == "string" && i.length > 0
  ).map((i) => i.trim()).join(" ");
}
const Sr = W({
  isTouched: !1,
  isLoading: !1,
  value: {},
  errors: {},
  updateFormValue: () => {
  }
});
function Cr({
  className: l,
  disabled: i,
  onClick: d,
  children: v,
  title: w,
  type: x = "button",
  flavor: f = "raised",
  color: g = "none"
}) {
  return /* @__PURE__ */ p.jsx(
    "button",
    {
      type: x,
      className: se(
        "py-2 px-3 flex justify-center items-center gap-2 rounded-md",
        (f === "raised" || f === "outline") && "shadow-slate-300 hover:shadow-slate-400 hover:shadow-md",
        f === "raised" && "shadow-md shadow-slate-300 hover:shadow-slate-400",
        f === "outline" && "border-2 border-slate-600",
        f === "raised" && g === "primary" && "bg-indigo-600 hover:bg-indigo-400 text-white",
        f === "raised" && g === "danger" && "bg-red-600 hover:bg-red-400 text-white",
        f === "raised" && g === "success" && "bg-green-400",
        f === "raised" && g === "warning" && "bg-yellow-400",
        f === "clear" && g == "primary" && "text-primary-700",
        f === "clear" && g === "danger" && "text-red-700",
        f === "clear" && g === "success" && "text-green-700",
        f === "clear" && g === "warning" && "text-yellow-700",
        f === "outline" && g === "primary" && "text-indigo-600 !border-violet-200 bg-indigo-50 hover:bg-white",
        f === "outline" && g === "danger" && "text-red-600 !border-red-200 bg-red-100 hover:bg-white",
        f === "outline" && g === "success" && "text-green-600 !border-green-200 bg-green-100 hover:bg-white",
        f === "outline" && g === "warning" && "text-yellow-700 !border-yellow-700",
        i && "opacity-50 cursor-not-allowed",
        l
      ),
      disabled: i,
      onClick: (h) => {
        h.stopPropagation(), d == null || d();
      },
      title: w,
      children: v
    }
  );
}
function K({ name: l, className: i = "" }) {
  return /* @__PURE__ */ p.jsx("i", { className: se("bx", l, i) });
}
function Ne({ className: l }) {
  return /* @__PURE__ */ p.jsx(
    "div",
    {
      className: se(
        "flex justify-center items-center text-2xl p-2",
        l
      ),
      children: /* @__PURE__ */ p.jsx(K, { className: "animate-spin", name: "bx-loader-alt" })
    }
  );
}
function Ie({
  children: l,
  type: i = "submit",
  flavor: d = "raised",
  color: v = "primary",
  ...w
}) {
  const { isLoading: x } = $(Sr);
  return /* @__PURE__ */ p.jsxs(
    Cr,
    {
      disabled: x,
      type: i,
      flavor: d,
      color: v,
      ...w,
      children: [
        x && /* @__PURE__ */ p.jsx(Ne, {}),
        l
      ]
    }
  );
}
function Pr({
  message: l,
  closeModal: i,
  onConfirm: d,
  onCancel: v
}) {
  return /* @__PURE__ */ p.jsxs("article", { className: "bg-white/95 backdrop-blur-sm border border-white/20 rounded-2xl shadow-2xl p-6 flex flex-col gap-6 max-w-md w-11/12", children: [
    /* @__PURE__ */ p.jsxs("div", { className: "flex items-center gap-3 mb-2", children: [
      /* @__PURE__ */ p.jsx("div", { className: "p-2 bg-gradient-to-r from-amber-500 to-orange-500 rounded-lg", children: /* @__PURE__ */ p.jsx(
        K,
        {
          name: "bx-help-circle",
          className: "text-white text-lg"
        }
      ) }),
      /* @__PURE__ */ p.jsx("h3", { className: "text-lg font-semibold text-gray-900", children: "Confirmar acción" })
    ] }),
    /* @__PURE__ */ p.jsx("div", { className: "px-2", children: /* @__PURE__ */ p.jsx("p", { className: "text-gray-700 leading-relaxed", children: l }) }),
    /* @__PURE__ */ p.jsxs("div", { className: "flex gap-3 justify-center pt-4 border-t border-gray-200/60", children: [
      /* @__PURE__ */ p.jsxs(
        Ie,
        {
          flavor: "outline",
          className: "px-6 py-3 rounded-xl font-medium transition-all duration-200 hover:bg-gray-50",
          onClick: () => {
            v == null || v(), i();
          },
          children: [
            /* @__PURE__ */ p.jsx(K, { name: "bx-x", className: "mr-2" }),
            "Cancelar"
          ]
        }
      ),
      /* @__PURE__ */ p.jsxs(
        Ie,
        {
          className: "bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-semibold px-6 py-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 border-0",
          onClick: () => {
            d == null || d(), i();
          },
          children: [
            /* @__PURE__ */ p.jsx(K, { name: "bx-check", className: "mr-2" }),
            "Confirmar"
          ]
        }
      )
    ] })
  ] });
}
function Or() {
  return /* @__PURE__ */ p.jsx("article", { className: "bg-white rounded p-4 flex flex-col gap-2 max-w-md w-11/12", children: /* @__PURE__ */ p.jsx(Ne, {}) });
}
function Wr({ children: l }) {
  const [i, d] = ae([]), [v, w] = ae(0), x = i.length > 0 || v > 0;
  Le(() => {
    if (!x || typeof window > "u") return;
    const u = {
      overflow: document.body.style.overflow,
      position: document.body.style.position,
      top: document.body.style.top,
      width: document.body.style.width
    }, b = window.scrollY;
    return document.body.style.overflow = "hidden", document.body.style.position = "fixed", document.body.style.top = `-${b}px`, document.body.style.width = "100%", () => {
      document.body.style.overflow = u.overflow, document.body.style.position = u.position, document.body.style.top = u.top, document.body.style.width = u.width, window.scrollTo(0, b);
    };
  }, [x]);
  const f = q(() => {
    w((u) => u + 1);
  }, []), g = q(() => {
    w((u) => Math.max(0, u - 1));
  }, []);
  function h(u) {
    const b = kr();
    return d((P) => [...P, { id: b, modal: u }]), b;
  }
  function C(u) {
    d(
      (b) => b.filter((P) => P.id !== u)
    );
  }
  const E = q(
    (u, b, P) => {
      const G = h(
        /* @__PURE__ */ p.jsx(
          Pr,
          {
            message: u,
            onConfirm: b,
            onCancel: P,
            closeModal: () => C(G)
          }
        )
      );
    },
    []
  ), S = q(
    (u, b) => {
      const P = h(
        ie.createElement(u, {
          ...b,
          closeModal: () => C(P)
        })
      );
    },
    []
  );
  return /* @__PURE__ */ p.jsxs(
    Tr.Provider,
    {
      value: {
        showConfirmationModal: E,
        withLoadingModal: async (u) => {
          const b = h(/* @__PURE__ */ p.jsx(Or, {}));
          try {
            return await u();
          } finally {
            C(b);
          }
        },
        showCustomModal: S,
        lockBodyScroll: f,
        unlockBodyScroll: g
      },
      children: [
        l,
        i.length > 0 && /* @__PURE__ */ p.jsx("div", { className: "fixed top-0 left-0 right-0 bottom-0 z-50 w-screen bg-black bg-opacity-50 flex justify-center items-center", children: i.map((u) => /* @__PURE__ */ p.jsx(wr, { children: u.modal }, u.id)) })
      ]
    }
  );
}
function kr() {
  let l = "";
  const i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", d = i.length;
  for (let v = 0; v < 10; v++)
    l += i.charAt(
      Math.floor(Math.random() * d)
    );
  return l;
}
function ue(l, i) {
  let d = "pending", v;
  const w = l.then((x) => {
    d = "resolved", v = x;
  });
  return {
    read: () => {
      if (d === "pending")
        throw w;
      return v;
    },
    refresh: () => ue(i(), i)
  };
}
const Fr = ue(
  Promise.resolve(void 0),
  () => Promise.resolve(void 0)
);
function $r() {
  return function(i, d) {
    const v = _r(), [w, x] = ae(Fr), f = w.read();
    return Le(() => {
      x(
        ue(
          v.call(i, d),
          () => v.call(i, d)
        )
      );
    }, [JSON.stringify(d)]), [f, () => x(w.refresh())];
  };
}
export {
  Cr as B,
  Mr as E,
  Sr as F,
  K as I,
  Ne as L,
  Tr as M,
  Ir as R,
  _r as a,
  Yr as b,
  se as c,
  z as d,
  Ie as e,
  Wr as f,
  Lr as g,
  jr as h,
  ue as i,
  p as j,
  $r as k,
  Nr as u
};
